import React, { useEffect, useRef, useState } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import GithubLogo from "../images/logos/github-logo.inline.svg"
import FreecodecampLogo from "../images/logos/freecodecamp-logo.inline.svg"

const RECAPTCHA_SITE_KEY =
  process.env.GATSBY_SITE_RECAPTCHA_KEY ||
  "6LdnkKEqAAAAAPvyqoRAmjXxvE6evlb5z-5Ol90Y"

export default function Footer() {
  const recaptchaRef = useRef(null)
  const [isClient, setIsClient] = useState(false)
  const [messageSent, setMessageSent] = useState(false)
  const [error, setError] = useState("")

  useEffect(() => {
    setIsClient(true)
  }, [])

  function handleSubmit(e) {
    e.preventDefault()
    setError("")

    const form = e.target
    const recaptchaValue = recaptchaRef.current?.getValue()

    if (!recaptchaValue) {
      setError("Please complete the reCAPTCHA.")
      return
    }

    const params = new URLSearchParams(new FormData(form))
    params.set("g-recaptcha-response", recaptchaValue)

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: params.toString(),
    })
      .then(response => response.text())
      .then(text => {
        if (text.includes("form submission has been received")) {
          setMessageSent(true)
          form.reset()
          recaptchaRef.current?.reset()
        } else {
          setError("Something went wrong. Please try again.")
        }
      })
      .catch(() => setError("Something went wrong. Please try again."))
  }

  return (
    <footer>
      <div className="contact" id="contact">
        <div className="contactText">
          <h3>Contact</h3>
          <p>
            If you would like to get in touch with me, please send me a message
            or reach out to me through any of my social media channels.
          </p>
          <div className="socialIcons">
            <a href="https://github.com/kpav33">
              <GithubLogo />
            </a>
            <a href="https://forum.freecodecamp.org/u/kpav/summary">
              <FreecodecampLogo />
            </a>
          </div>
        </div>
        <form
          className="contactForm"
          name="contact"
          method="post"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          data-netlify-recaptcha="true"
          onSubmit={handleSubmit}
        >
          {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
          <input type="hidden" name="form-name" value="contact" />
          <p hidden>
            <label>
              Don’t fill this out: <input name="bot-field" />
            </label>
          </p>
          <p>
            <label>
              Your email:
              <br />
              <input
                type="email"
                name="email"
                required
                placeholder="johndoe@example.com"
              />
            </label>
          </p>
          <p>
            <label>
              Message:
              <br />
              <textarea
                name="message"
                required
                placeholder="Write your message here..."
              />
            </label>
          </p>
          {isClient && (
            <ReCAPTCHA ref={recaptchaRef} sitekey={RECAPTCHA_SITE_KEY} />
          )}
          <p>
            <button type="submit">Send</button>
          </p>
          {messageSent && <p>Message sent successfully!</p>}
          {error && <p>{error}</p>}
        </form>
      </div>
      <div className="footerInfo">
        <p>
          <AnchorLink to="/" title="Top of page">
            Built by Klemen Pavlovič
          </AnchorLink>
        </p>
        <p>
          Images from <a href="https://drawkit.com/">DrawKit</a>, SVG icons from{" "}
          <a href="https://www.svgrepo.com/">SVGRepo</a>, favicon created on{" "}
          <a href="https://favicon.io/">favicon.io</a>.
        </p>
      </div>
    </footer>
  )
}
